// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-js": () => import("/opt/build/repo/src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-about-js": () => import("/opt/build/repo/src/pages/about.js" /* webpackChunkName: "component---src-pages-about-js" */),
  "component---src-pages-contact-js": () => import("/opt/build/repo/src/pages/contact.js" /* webpackChunkName: "component---src-pages-contact-js" */),
  "component---src-pages-index-js": () => import("/opt/build/repo/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-work-components-insta-image-insta-image-js": () => import("/opt/build/repo/src/pages/work/components/InstaImage/InstaImage.js" /* webpackChunkName: "component---src-pages-work-components-insta-image-insta-image-js" */),
  "component---src-pages-work-index-js": () => import("/opt/build/repo/src/pages/work/index.js" /* webpackChunkName: "component---src-pages-work-index-js" */)
}

